"use strict";var t=require("@apollo/client"),e=t.gql`
  mutation updateCustomer($customerData: CustomerUpdateInput!) {
    updateCustomer(customerData: $customerData) {
      id
      name
      phoneNumber
      email
      terms
      notifications
      documentId
      uid
      phoneNumberValidated
      customData
    }
  }
`,a=t.gql`
  mutation updateCustomerWithProxy($customerData: CustomerUpdateInput!) {
    updateCustomerWithProxy(customerData: $customerData) {
      id
      name
      phoneNumber
      email
      terms
      notifications
      documentId
      uid
      phoneNumberValidated
      customData
    }
  }
`;exports.a=a,exports.u=e;